import { render, staticRenderFns } from "./Reglamento.vue?vue&type=template&id=794f3ff0&"
import script from "./Reglamento.vue?vue&type=script&lang=js&"
export * from "./Reglamento.vue?vue&type=script&lang=js&"
import style0 from "./Reglamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports